var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPercentUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0974 4.70339L12.0574 5.66339L8.80404 8.91672L6.61071 6.72339C6.35071 6.46339 5.93071 6.46339 5.67071 6.72339L1.67071 10.7301C1.41071 10.9901 1.41071 11.4101 1.67071 11.6701C1.93071 11.9301 2.35071 11.9301 2.61071 11.6701L6.13737 8.13672L8.33071 10.3301C8.59071 10.5901 9.01071 10.5901 9.27071 10.3301L12.9974 6.61005L13.9574 7.57005C14.164 7.77672 14.524 7.63005 14.524 7.33672V4.47005C14.5307 4.28339 14.384 4.13672 14.1974 4.13672H11.3374C11.0374 4.13672 10.8907 4.49672 11.0974 4.70339Z",
    fill: "#059666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentUp);
export default __webpack_public_path__ + "static/media/PercentUp.a2096200b429a52464c482e8a6bbcae4.svg";
export { ForwardRef as ReactComponent };